import React from "react";
import { Route, Routes } from "react-router-dom";
import PartnersOutlet from "../pages/Partners/PartnersOutlet";
import PartnersPage from "../pages/Partners";
import CreatePartnerPage from "../pages/Partners/CreatePartnerPage";
import EditPartnerPage from "../pages/Partners/EditPartnerPage";
import PartnerAppsPage from "../pages/Partners/PartnerAppsPage";
import CreatePartnerAppPage from "../pages/Partners/CreatePartnerAppPage";
import EditPartnerAppPage from "../pages/Partners/EditPartnerAppPage";
import EditAppCredentialSettingsPage from "../pages/Partners/EditAppCredentialSettingsPage";
import AppCredentialsPage from "../pages/Partners/AppCredentialsPage";

export function PartnerRoutes() {
    return (
        <Routes>
            <Route path="/" element={<PartnersOutlet />}>
                <Route index element={<PartnersPage />} />
                <Route path="create" element={<CreatePartnerPage />} />
                <Route path=":id/edit" element={<EditPartnerPage />} />
                <Route path=":id" element={<PartnerAppsPage />} />
                <Route path=":id/apps/create" element={<CreatePartnerAppPage />} />
                <Route path=":id/apps/:appId" element={<AppCredentialsPage />} />
                <Route path=":id/apps/:appId/edit" element={<EditPartnerAppPage />} />
                <Route path=":id/apps/:appId/credential-settings" element={<EditAppCredentialSettingsPage />} />
            </Route>
        </Routes>
    );
}
